import { SamplePack } from '@arpeggi/shared'
import { FC } from 'react'
import { useSamplePackCollaborators } from '../../../__legacy__/queries/samplePacks'
import { Contributors } from '../primitives'

export const SPContributorsSection: FC<{ sp: SamplePack }> = ({ sp }) => {
  const collaboratorsQuery = useSamplePackCollaborators({ id: sp.id, params: { perPage: 10 } })

  if (collaboratorsQuery.isLoading) {
    return null
  }

  const totalContributors = collaboratorsQuery.data?.pages[0].meta.total

  return (
    <Contributors.Root>
      <Contributors.AvatarGroup>
        {collaboratorsQuery.data.pages.flatMap((page) =>
          page.data.map((user) => (
            <Contributors.Avatar key={user.walletAddress} src={user.profilePicture?.url} />
          ))
        )}
      </Contributors.AvatarGroup>
      <Contributors.Count>{`${totalContributors} contributors`}</Contributors.Count>
    </Contributors.Root>
  )
}
